<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    
    <div class="hero-section">
      <p class="subtitle">Advanced coin recognition system based on deep learning, quickly and accurately identifying coins from around the world</p>
      <div class="download-container">
        <div class="download-buttons">
          <a href="https://play.google.com/store/apps/details?id=com.collect.coin.identifier" class="download-btn android-btn">
            <div class="btn-icon">
              <i class="fab fa-android"></i>
            </div>
            <div class="btn-text">
              <span class="btn-small">GET IT ON</span>
              <span class="btn-large">Google Play</span>
            </div>
          </a>
          <a href="https://apps.apple.com/us/app/go-coin-identifier-coin-value/id6739617412" class="download-btn ios-btn">
            <div class="btn-icon">
              <i class="fab fa-apple"></i>
            </div>
            <div class="btn-text">
              <span class="btn-small">Download on the</span>
              <span class="btn-large">App Store</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    
    <div class="product-intro">
      <h2 class="section-title">What is <span>Go Coin Identifier</span>?</h2>
      <div class="intro-description">
        <p>
          Go Coin Identifier is a cutting-edge coin recognition system that uses advanced AI and computer vision technology to identify coins from different countries, time periods, and denominations. Whether you're a collector, historian, or just curious about a coin you've found, our system provides fast and accurate identification.
        </p>
      </div>
      
      <div class="owl-carousel-container">
        <div class="owl-carousel owl-theme" ref="owlCarousel">
          <!-- All screenshots -->
          <div class="item"><img src="@/assets/8.BcoSMzo5.jpg" alt="App Screenshot 8" /></div>
          <div class="item"><img src="@/assets/1.BzxupHYW.jpg" alt="App Screenshot 1" /></div>
          <div class="item"><img src="@/assets/2.DmggXzdH.jpg" alt="App Screenshot 2" /></div>
          <div class="item"><img src="@/assets/3.Be2RhdDm.jpg" alt="App Screenshot 3" /></div>
          <div class="item"><img src="@/assets/4.CXJh0wvI.jpg" alt="App Screenshot 4" /></div>
          <div class="item"><img src="@/assets/5.DFEqfqHi.jpg" alt="App Screenshot 5" /></div>
          <div class="item"><img src="@/assets/6.BcoSMzo5.jpg" alt="App Screenshot 6" /></div>
          <div class="item"><img src="@/assets/7.DFEqfqHi.jpg" alt="App Screenshot 7" /></div>
        </div>
      </div>
      
      <div class="app-info" id="features">
        <h3>System Features</h3>
        <div class="features-container">
          <div class="feature-card">
            <div class="feature-icon">🔍</div>
            <h4>Precise Identification</h4>
            <p>Accurate identification of various coins, supporting multiple currencies and regions</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">⚡</div>
            <h4>Fast Processing</h4>
            <p>Quick processing of batch recognition tasks, improving efficiency and user experience</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📊</div>
            <h4>Detailed Analysis</h4>
            <p>Comprehensive coin data analysis, including era, denomination, and estimated value</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📱</div>
            <h4>User Friendly</h4>
            <p>Intuitive user interface with simple and convenient operation for all users</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🌐</div>
            <h4>Multi-language Support</h4>
            <p>Supports multiple languages and provides coin information in various international formats</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🔒</div>
            <h4>Privacy Protection</h4>
            <p>All data is processed locally on your device, ensuring your collection information remains private and secure</p>
          </div>
        </div>
      </div>
      
      <div class="tech-section" id="tech">
        <h3>Our Technology</h3>
        <p>We use state-of-the-art convolutional neural networks trained on hundreds of thousands of coin images to ensure high-precision recognition. Advanced image processing techniques extract key features from your coins, including text, symbols, edges, and wear patterns.</p>
      </div>
      
      <div class="use-cases" id="use-cases">
        <h3>Use Cases</h3>
        <div class="use-cards">
          <div class="use-card">
            <div class="use-icon">👨‍👩‍👧‍👦</div>
            <h4>Collectors</h4>
            <p>Quickly identify new coins in your collection and learn about their historical background</p>
          </div>
          <div class="use-card">
            <div class="use-icon">🏛️</div>
            <h4>Museums</h4>
            <p>Categorize and organize coin collections with detailed information</p>
          </div>
          <div class="use-card">
            <div class="use-icon">💼</div>
            <h4>Businesses</h4>
            <p>Efficiently and accurately process international currencies</p>
          </div>
          <div class="use-card">
            <div class="use-icon">🧠</div>
            <h4>Educators</h4>
            <p>Teach history and economics through the fascinating world of coins</p>
          </div>
        </div>
      </div>
      
      <div class="action-section">
        <h3>Get Our App</h3>
        <div class="download-container">
          <div class="download-buttons">
            <a href="https://apps.apple.com/us/app/go-coin-identifier-coin-value/id6739617412" class="download-btn ios-btn">
              <div class="btn-icon">
                <i class="fab fa-apple"></i>
              </div>
              <div class="btn-text">
                <span class="btn-small">Download on the</span>
                <span class="btn-large">App Store</span>
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.collect.coin.identifier" class="download-btn android-btn">
              <div class="btn-icon">
                <i class="fab fa-android"></i>
              </div>
              <div class="btn-text">
                <span class="btn-small">GET IT ON</span>
                <span class="btn-large">Google Play</span>
              </div>
            </a>
          </div>
        </div>
        <p class="action-note">*All coin identification features are only available in our mobile application</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      owlInstance: null // Store carousel instance
    }
  },
  methods: {
    preloadImages() {
      // Initialize carousel directly, no need to wait for image preloading
      this.initCarousel();
    },
    initCarousel() {
      this.$nextTick(() => {
        if (window.jQuery && window.jQuery.fn.owlCarousel && this.$refs.owlCarousel) {
          this.owlInstance = window.jQuery(this.$refs.owlCarousel).owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            autoHeight: true,
            responsive: {
              0: {
                items: 1,
                margin: 0,
                stagePadding: 0
              },
              600: {
                items: 1,
                margin: 10,
                stagePadding: 20
              },
              768: {
                items: 2,
                margin: 20
              },
              992: {
                items: 3,
                margin: 20
              }
            }
          });
        }
      });
    }
  },
  mounted() {
    this.preloadImages();
    
    // Re-initialize carousel on window resize
    window.addEventListener('resize', () => {
      if (this.owlInstance) {
        this.owlInstance.trigger('destroy.owl.carousel');
        this.initCarousel();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', () => {});
    if (this.owlInstance) {
      this.owlInstance.trigger('destroy.owl.carousel');
    }
  }
}
</script>

<style scoped>
*, *:before, *:after {
  box-sizing: border-box;
}

.hello {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0;
}

h1 {
  font-size: 42px;
  margin-bottom: 1rem;
  color: #333;
  font-weight: 700;
}

h2, h3, h4 {
  color: #333;
}

h2 {
  font-size: 32px;
  margin: 2rem 0;
}

h3 {
  font-size: 28px;
  margin: 40px 0 20px;
}

.section-title {
  text-align: center;
  position: relative;
}

.section-title span {
  color: #111855;
}

.hero-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}

.subtitle {
  font-size: 20px;
  line-height: 1.6;
  max-width: 800px;
  color: #555;
  margin-bottom: 30px;
}

.download-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.download-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  max-width: 100%;
}

.download-btn {
  display: flex;
  align-items: center;
  padding: 15px 25px;
  border-radius: 14px;
  text-decoration: none;
  color: white;
  min-width: 240px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  z-index: 1;
}

.download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transition: all 0.4s ease;
}

.android-btn::before {
  background: linear-gradient(135deg, #4285F4, #34a853);
}

.ios-btn::before {
  background: linear-gradient(135deg, #000000, #333333);
}

.download-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.15);
}

.download-btn:active {
  transform: translateY(-2px);
}

.btn-icon {
  font-size: 32px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.3;
}

.btn-small {
  font-size: 14px;
  font-weight: 400;
  opacity: 0.9;
}

.btn-large {
  font-size: 20px;
  font-weight: 600;
}

.product-intro {
  max-width: 1200px;
  margin: 0 auto 3rem;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
}

.intro-description {
  text-align: center;
  margin-bottom: 3rem;
}

.intro-description p {
  font-size: 20px;
  line-height: 1.8;
  color: #555;
}

.owl-carousel-container {
  margin: 30px auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  overflow: hidden;
  max-width: 1200px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.03);
  position: relative;
  padding: 40px 0;
}

.owl-carousel-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #111855, #ffd700);
  z-index: 1;
}

.owl-carousel .item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  height: 100%;
  min-height: 300px;
}

.owl-carousel img {
  width: 100%;
  height: auto;
  max-height: 750px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.owl-carousel img:hover {
  transform: scale(1.03);
}

.owl-nav {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  pointer-events: none;
}

.owl-prev, .owl-next {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}

.owl-prev:hover, .owl-next:hover {
  background: #ffd700 !important;
}

.owl-prev span, .owl-next span {
  font-size: 24px;
  color: #111855;
  font-weight: bold;
}

.owl-dots {
  margin-top: 20px;
  text-align: center;
}

.app-info {
  text-align: center;
  margin: 50px auto 0;
  background-color: #ffffff;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.03);
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
}

.app-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #111855, #ffd700);
}

.app-info h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  position: relative;
  display: inline-block;
}

.app-info h3::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #111855, #ffd700);
  border-radius: 3px;
}

.features-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 25px;
  max-width: 1200px;
  margin: 30px auto 0;
  padding: 0 15px;
  box-sizing: border-box;
}

@media (min-width: 1200px) {
  .features-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .features-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .features-container {
    grid-template-columns: 1fr;
  }
}

.feature-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 20px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.03);
  height: 100%;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #111855, #ffd700);
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 42px;
  margin-bottom: 20px;
  display: inline-block;
  background: linear-gradient(135deg, #111855, #ffd700);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.feature-card h4 {
  font-size: 20px;
  margin: 0 0 15px;
  color: #333;
  font-weight: 600;
}

.feature-card p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.tech-section {
  background-color: #ffffff;
  padding: 40px 20px;
  border-radius: 15px;
  margin: 50px 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.tech-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #ffd700, #111855);
}

.tech-section h3 {
  margin-top: 0;
}

.tech-section p {
  font-size: 18px;
  color: #555;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}

.use-cases {
  margin: 50px 0;
  text-align: center;
}

.use-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
}

.use-card {
  flex: 1;
  min-width: 200px;
  max-width: 250px;
  background-color: #ffffff;
  padding: 30px 20px;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  border: 1px solid rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
}

.use-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(180deg, #111855, #ffd700);
}

.use-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.use-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: #111855;
}

.use-card h4 {
  margin: 0.5rem 0;
  font-size: 20px;
  color: #333;
}

.use-card p {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
}

.action-section {
  text-align: center;
  margin: 50px 0;
  background-color: #ffffff;
  padding: 40px 20px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.action-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #111855, #ffd700);
}

.action-note {
  font-size: 16px;
  color: #777;
  font-style: italic;
  margin-top: 20px;
}

.contact {
  text-align: center;
  margin: 50px 0;
  background-color: #f9f9f9;
  padding: 40px 20px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.contact h3 {
  margin-top: 0;
}

.contact p {
  font-size: 18px;
  color: #555;
  margin-bottom: 30px;
}

.contact a {
  color: #111855;
  text-decoration: none;
  font-weight: 500;
}

.contact a:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .download-buttons {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .download-btn {
    width: 100%;
    max-width: 280px;
    justify-content: center;
  }
  
  h1 {
    font-size: 32px;
  }
  
  h2 {
    font-size: 28px;
  }
  
  .subtitle {
    font-size: 18px;
  }
  
  .intro-description p {
    font-size: 18px;
  }
}

@media (max-width: 992px) {
  .features-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .hello {
    padding: 0;
  }
  
  .product-intro {
    padding: 0 10px;
    width: 100%;
    max-width: 100%;
  }
  
  .use-cards {
    flex-direction: column;
    align-items: center;
  }
  
  .use-card {
    width: 100%;
    max-width: 100%;
  }
  
  .owl-carousel-container {
    padding: 20px 0;
    margin: 20px auto;
    border-radius: 12px;
  }
  
  .owl-carousel .item {
    padding: 10px;
  }
  
  .owl-carousel img {
    max-height: 600px;
    border-radius: 10px;
    object-fit: contain;
  }
  
  .owl-prev, .owl-next {
    width: 35px;
    height: 35px;
  }
  
  .app-info {
    padding: 30px 15px;
    margin: 40px auto;
    width: calc(100% - 20px);
    max-width: 100%;
  }
  
  .features-container {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0;
    width: 100%;
    max-width: 100%;
    margin: 20px auto 0;
  }
  
  .feature-card {
    padding: 25px 15px;
    width: 100%;
    margin-bottom: 15px;
    min-height: auto;
    max-width: 100%;
  }
  
  .feature-card h4 {
    font-size: 18px;
    margin: 0 0 12px;
  }
  
  .feature-card p {
    font-size: 15px;
    line-height: 1.5;
  }
  
  .feature-icon {
    font-size: 36px;
    margin-bottom: 15px;
  }
  
  .tech-section, .use-cases, .action-section {
    margin: 40px auto;
    width: calc(100% - 20px);
    max-width: 100%;
  }
  
  .download-buttons {
    gap: 25px;
  }
  
  .download-btn {
    padding: 15px 25px;
    min-width: 280px;
    border-radius: 14px;
  }
  
  .btn-icon {
    font-size: 32px;
    margin-right: 18px;
  }
  
  .btn-small {
    font-size: 14px;
  }
  
  .btn-large {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 28px;
  }
  
  h2 {
    font-size: 24px;
  }
  
  h3 {
    font-size: 22px;
  }
  
  .product-intro {
    padding: 0 5px;
  }
  
  .app-info {
    padding: 25px 10px;
    margin: 30px auto;
    width: calc(100% - 10px);
    max-width: 100%;
  }
  
  .tech-section, .use-cases, .action-section {
    padding: 25px 10px;
    margin: 30px auto;
    width: calc(100% - 10px);
    max-width: 100%;
  }
  
  .download-buttons {
    gap: 20px;
  }
  
  .download-btn {
    padding: 14px 20px;
    min-width: 240px;
    border-radius: 12px;
  }
  
  .btn-icon {
    font-size: 30px;
    margin-right: 15px;
  }
  
  .btn-small {
    font-size: 13px;
  }
  
  .btn-large {
    font-size: 18px;
  }
  
  .owl-carousel-container {
    padding: 15px 0;
    margin: 15px auto;
    border-radius: 10px;
  }
  
  .owl-carousel .item {
    padding: 5px;
  }
  
  .owl-carousel img {
    max-height: 450px;
    border-radius: 8px;
    object-fit: contain;
  }
  
  .owl-prev, .owl-next {
    width: 30px;
    height: 30px;
  }
  
  .owl-prev span, .owl-next span {
    font-size: 20px;
  }
  
  .app-info h3 {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  .app-info h3::after {
    width: 50px;
    bottom: -8px;
  }
  
  .features-container {
    gap: 15px;
    padding: 0;
  }
  
  .feature-card {
    padding: 20px 10px;
    margin-bottom: 10px;
  }
  
  .feature-card h4 {
    font-size: 16px;
    margin: 0 0 10px;
  }
  
  .feature-card p {
    font-size: 14px;
    line-height: 1.4;
  }
  
  .feature-icon {
    font-size: 32px;
    margin-bottom: 12px;
  }
  
  .app-info {
    padding: 25px 10px;
    margin: 30px auto 0;
    width: 100%;
    max-width: calc(100% - 10px);
  }
  
  .tech-section, .use-cases, .action-section {
    padding: 25px 10px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 10px);
  }
}

.custom-dots {
  text-align: center;
  margin-top: 25px;
  margin-bottom: 15px;
}

.custom-dots .dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.15);
  margin: 0 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.custom-dots .dot::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #111855, #ffd700);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.custom-dots .dot:hover::before {
  opacity: 0.5;
}

.custom-dots .dot.active {
  background-color: transparent;
  width: 18px;
  height: 18px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
}

.custom-dots .dot.active::before {
  opacity: 1;
}

.group-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}

.group-item > div {
  flex: 0 0 32%;
  margin: 0;
}

.group-item img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
}

.group-item img:hover {
  transform: scale(1.03);
}

.desktop-only {
  display: flex;
}

.mobile-only {
  display: none;
}

.desktop-dots {
  display: block;
}

.mobile-dots {
  display: none;
}

</style>
